import { MachineList } from 'app/modules/machine-inventory/machine-list/components/MachineList/MachineList';

export const MachineListPage = (): JSX.Element => <MachineList />;
